var campusIndex = ["ㄱ", "ㄴ", "ㄷ", "ㄹ", "ㅁ", "ㅂ", "ㅅ", "ㅇ", "ㅈ", "ㅊ", "ㅋ", "ㅌ", "ㅍ", "ㅎ", "기타"];
var campus = [
    ["가천대", "가톨릭대", "강남대", "강릉원주대", "강원대", "건국대", "건국대(글로컬)", "건양대", "경기대", "경민대", "경북대", "경상대", "경성대", "경인교대", "경일대", "경찰대학", "경희대", "경희대(국제)", "계명대", "계원예대", "고려대", "고려대(세종)", "공군사관학교", "공주대", "광운대", "광주대", "국민대", "국제패션학교", "금오공과대"],
    ["남부대", "남서울대", "노인대학"],
    ["단국대", "단국대(천안)", "대구가톨릭대", "대구대", "대전대", "대진대", "덕성여대", "동국대", "동국대(경주)", "동덕여대", "동명대", "동서대", "동아대", "동아방송예술대", "동양대", "동양미래대", "동원대", "동의대"],
    ["라사라패션학교"],
    ["명지대", "목원대"],
    ["배재대", "배화여대", "백석대", "부경대", "부산가톨릭대", "부산경상대", "부산대", "부산외대"],
    ["삼육대", "삼성디자인스쿨", "상명대", "상명대(천안)", "상지대", "서강대", "서경대", "서울과기대", "서울교대", "서울대", "서울모드패션학교", "서울시립대", "서울여대", "서울예대", "서울예술전문학교", "서울종합예술학교", "서원대", "성균관대", "성신여대", "세종대", "수원대", "수원여대", "숙명여대", "순천대", "순천향대", "숭실대", "숭의여대", "신구대", "신라대", "신성대", "신한대"],
    ["아주대", "안동대", "안양대", "에스모드패션학교", "연성대", "연세대", "연세대(원주)", "영남대", "영동대", "용인대", "용인송담대", "우송대", "울산대", "원광대", "유니스트", "육군사관학교", "을지대", "이화여대", "인천대", "인하공업전문대학", "인하대"],
    ["전남대", "전북대", "전주대", "제주대", "조선대", "중부대", "중앙대", "중앙대(안성)"],
    ["창원대", "청강문화산업대", "청주대", "청운대", "충남대", "충북대"],
    ["카이스트"],
    [""],
    ["평택대", "포항공대"],
    ["한경대", "한국교통대", "한국기술교육대", "한국산기대", "한국영상대", "한국외대", "한국외대(글로벌)", "한국체대", "한국항공대", "한국해양대", "한남대", "한동대", "한림대", "한밭대", "한서대", "한성대", "한세대", "한신대", "한양대", "한양대(ERICA)", "한양여대", "한예종", "해군사관학교", "협성대", "호서대", "홍익대", "홍익대(세종)"],
    [""],
];

var street = ["가로수길", "동대문", "명동", "서면", "이태원", "홍대입구", "시부야", "신주쿠", "하라주쿠"];

var festival = [
    // INSPIRED NIGHT, 서울 패션 페스티벌, 스펙트럼, 워터밤
    "CAMSCON Inspired Night", "GO OUT CAMP", "RAPBEAT SHOW", "그랜드민트 페스티벌", "그린플러그드서울", "글로벌개더링코리아",
    "레인보우아일랜드", "서울재즈페스티벌", "서울 패션페스티벌", "스펙트럼", "울트라 뮤직 페스티벌", "워터밤 페스티벌", "월드 DJ 페스티벌",
    "자라섬 재즈 페스티벌", "지산 밸리록 페스티벌", "펜타포트 락페스티벌", "하이네켄 스타디움", "힙합플레이야 페스티벌"
];


var brandIndex = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "etc" ];

var brand = [
    ["Adidas", "Americal Apperal", "Asics", "Basic House", "Bean Pole", "Bershka", "Beyond Closet", "Brown Breath"],
    [],
    ["CHARM\"S", "CRITIC", "Carhartt", "Champion", "Converse", "Customellow"],
    ["DIM.E.CRES.", "Descente", "Dr.Martens"],
    ["8 Seconds"],
    ["FILA", "Forever 21", "Freitag"],
    ["Gentle Monster"],
    ["H&M"],
    [],
    [],
    [],
    ["Lacoste", "Lecoq", "Liful", "Low Classic", "Lucky Chouette"],
    ["Mis Chief", "Munsoo Kwon", "New Balance"],
    ["Nike"],
    ["OiOi", "Ordinary People"],
    ["POLHAM", "Puma", "Push Button"],
    [],
    ["Reebok", "Rocket X Lunch"],
    ["SPAO", "Sewing Boundaries", "Style Nanda"],
    ["T.I.For Men", "The class", "This is never That", "Timberland", "Tomboy", "Topten"],
    ["Umbro", "Uniqlo"],
    ["VANS"],
    [],
    [],
    [],
    ["ZARA", "ZIOZIA"],
    [],
];

export const MenuData = {
    campusIndex: campusIndex,
    campus: campus,
    street: street,
    festival: festival,
    brandIndex: brandIndex,
    brand: brand
};

// export const MagazineMenuData = ["에디토리얼", "패션", "뷰티", "스니커즈", "뮤직", "피쳐", "인터뷰", "라이프", "테크", "스포츠", "*걸스콘", "*힙스콘"];

export const MagazineMenuData = ["에디토리얼", "인터뷰", "피처", "패션", "뷰티", "스니커즈", "액세서리", "뮤직", "테크", "푸드", "아트", "자동차", "토이", "영화", "스포츠", "기타"];
